import React from 'react';
import { trackPropTypes } from "../../../config/defaults";
import SkierIcon from "../../UI/SkierIcon";
import Label from "@/components/UI/Label";
import {
	getLearningAreaColors,
	getLearningAreaLabelColors
} from "@/config/learningAreas";

/**
 * Навчальний майданчик 2D/E
 *
 * Координати з Figma:
 * - Позиція на карті: translate(1460, 886)
 * - Розмір області: 55.94 × 57.52 px
 *
 * TODO: Додати SVG path для області майданчика
 */

const Track2DGreen = ({ state, workState, onLabelClick }) => {
	const colors = getLearningAreaColors(state, workState);
	const labelColors = getLearningAreaLabelColors(state, workState);

	return (
		<g id="Track2DGreen" transform="translate(1485, 910)" className="learning-area">
			<g transform="translate(11, -8)">
				<path d="M0.500244 0.788452C4.13961 -0.296341 7.9693 1.77455 9.05409 5.41391L9.39569 6.55994"
							stroke={colors.connector}

							strokeLinecap="round"/>
			</g>

			{/* Область навчального майданчика */}
			<g transform="translate(0, 0)">
				<path
					d="M18.4221 2.2924C21.5391 -0.331989 26.1853 0.0302635 28.8585 3.10551L32.3795 7.15534C35.0302 10.2047 34.7717 14.8108 31.7966 17.5445L17.3235 30.8438C14.3183 33.6051 9.65189 33.4387 6.85022 30.471L2.57453 25.943C-0.368327 22.8256 -0.0849758 17.8746 3.19434 15.1134L18.4221 2.2924Z"
					fill={colors.areaFill} stroke={colors.areaBorder} strokeWidth="1.07815"/>
			</g>


			<g transform="translate(9, 9)">
				<rect
					width="16"
					height="16"
					rx="8"
					fill={colors.skierBg}
				/>
				<g transform="translate(3, 3)">
					<SkierIcon color="white" size={12} variant="simple"/>
				</g>
			</g>

			{/* Мітка 2D */}
			<Label
				onClick={(event, ref) => onLabelClick(event, ref, 'Track2DGreen')}
				coords="-15, -15"
				text="2D"
				textCoordsX="7"
				textCoordsY="16"
				colors={labelColors.colors}
				textColor={labelColors.textColor}
				textSize={10}
				size="small"
			/>
		</g>
	);
};

Track2DGreen.propTypes = trackPropTypes;

export default Track2DGreen;
